import {
  Directive,
  inject,
  Input,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { AuthService } from '@services/auth.service';
import { UserRole } from '../enums/user-role';

@Directive({
  selector: '[hasRole]',
  standalone: true,
})
export class HasRoleDirective implements OnInit {
  private authService = inject(AuthService);
  private templateRef = inject(TemplateRef);
  private viewContainer = inject(ViewContainerRef);
  private roles: UserRole[] = [];
  @Input() set hasRole(roles: UserRole[]) {
    this.roles = roles;
  }

  ngOnInit(): void {
    const userRole = this.authService.user().role;
    const hasRole = this.roles.includes(userRole);
    if (hasRole) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
